(function() {
    if(typeof(console) === 'undefined') {
        console = { log: function() {}, warn: function() {}};
    }
    //var baseUrl = ''
    var baseUrl = 'https://localhost:44384'
    var dataWidgetId = '0fb6d6bb-00c3-40af-abb7-bea3251bb7c1'
    var dashboardFilterAttributeId = '1968837a-5c1a-482d-9a2f-f82869ad7b5e'
    function setup_css() {
        if($('link.mangl-transcript-style').length > 0) return;
        var css = document.createElement('link');
        css.rel = 'stylesheet'
        css.type='text/css'
        css.href=baseUrl+'/Scripts/Core/mangl-transcript.css?_' + (Math.random() * 1000)
        css.className='mangl-transcript-style'
        var head  = document.getElementsByTagName('HEAD')[0];
        if(head) head.appendChild(css)
    }

    function loadWidgetData(widgetId, callId) {
        var dateStart = '2022-01-01', dateEnd= '2022-01-02', divisionId = $('#SelectedDivision').val();
        // var v1 = $('.dashboard-filter[data-short-id="1968837a-5c1a-482d-9a2f-f82869ad7b5e"]');
        // var kv = v1.data("kendoMultiSelect")        
        // kv.value(callId);
        //kv.trigger("change");

        //MDB.loadWidgetData: function (id, dateStart, dateEnd, divisionId)
        return MDB.loadWidgetData(widgetId, dateStart, dateEnd, divisionId);
    }
    

    window.initManglTranscript = function(config /*widgetId, callIdColumn*/) {
		var dnxUserId = (config.dnxUserId || '').toUpperCase()
        var callIdColumn = config.callIdColumn;
        var widgetId = config.widgetId;
        dashboardFilterAttributeId = (config.dashboardFilterAttributeId || dashboardFilterAttributeId).toLowerCase()
        dataWidgetId = config.dataWidgetId || '';
        baseUrl = config.baseUrl;

		var dnxUsersForDataWidget = ["A7E42414-AC82-4E7D-91C1-6FCDBCC4D145", "2B0ADB93-BE4C-4918-9158-34D954E36F68"]
		var dataWidget = $('.widget[data-id="'+dataWidgetId.toLowerCase()+'"]');
		//console.log(dnxUsersForDataWidget, dnxUserId, dnxUsersForDataWidget.filter(function(v) { return v == dnxUserId }))
		if(dnxUsersForDataWidget.filter(function(v) { return  v == dnxUserId }).length > 0) {
			// show data widget
			dataWidget.show();
			setTimeout(function() {
				dataWidget.css('display','none');	
			}, 1000 * 25);
		} else {
			// hide data widget
			dataWidget.css('display','none');
		}
        //    widgetId: "'+convert(nvarchar(40),@dnxWidgetId) + '",
	    //dataWidgetId: "0fb6d6bb-00c3-40af-abb7-bea3251bb7c1",
	    //baseUrl: "'+@baseUrl+'"

        // list need to be loaded to be able to set the value
        $('.dashboard-filter[data-short-id="'+ dashboardFilterAttributeId+ '"]').data("kendoMultiSelect").dataSource.pageSize(1000 * 1000);
        $('.dashboard-filter[data-short-id="'+ dashboardFilterAttributeId+ '"]').data("kendoMultiSelect").dataSource.fetch();

        if(!callIdColumn) callIdColumn= 1;
        setup_css();
        
        var rows = $('.widget[data-id="'+widgetId.toLowerCase()+'"] .table tr');
        //console.log(rows);
        rows.css('cursor','pointer').bind('click', function(e) {
            let callId = $(this).find('td:eq('+callIdColumn+')').text();
            
            window.showManglTranscript(widgetId, callId);
     //alert(callId)
        })
        //console.log(tbl);
        //alert(widgetId)
        console.log('transcript ready')

    }
    var activeElement;
	var activeOverlay;
    window.showManglTranscript = function(widgetId, callId) {
		
        //$('.active-transcript').remove();
		if(activeOverlay) activeOverlay.remove();
        if(activeElement) activeElement.remove();
        activeElement = null;

		activeOverlay = $('<div />', {'class': 'mangl-transcript-overlay active-overlay' });
		
        var element = $('<div />', {
            'class': 'mangl-transcript-popup mtp active-transcript',
           'css': { }
        });
        activeElement = element;
        // SET FILTER VALUE
        // var v1 = $('.dashboard-filter[data-short-id="1968837a-5c1a-482d-9a2f-f82869ad7b5e"]');
        // var kv = v1.data("kendoMultiSelect")        
        // // attempt both upper & lower case
        // kv.dataSource.filter({"value": callId.toUpperCase()})

        MDB.Charts.setFilters({"attributeId": dashboardFilterAttributeId, values: callId.toUpperCase()})

        // kv.dataSource.fetch(function() {

        // });
        setTimeout(function(){
            // need to wait 1 tick after setting /loading the filter
          //  kv.value(callId.toUpperCase()) && kv.trigger("change");
            console.log("start loading data")
            setTimeout(function() {
				var retryCount = 0;
				function on_widgetdata_received(data) {
					var callIdFromData = ""
					if(data.length > 0) {
						var x = data[0];
						var keys = Object.keys(x).filter(function(x) { return x && x.toLowerCase() == "callid"})
						if(keys.length > 0) callIdFromData =x[keys[0]];
						
					}
					if(callIdFromData && callIdFromData.toLowerCase() == callId.toLowerCase()) {					
						console.warn("data loaded", callId)	
						showManglTranscriptStep2(element,widgetId, callId, data);
						
					} else {
						// retry
						if(retryCount++ < 5){
							if(callIdFromData && callIdFromData != callId) 
								console.log(" Received data for an old call. Delay untill filters are loaded ... retrying ...", callId, callIdFromData);
							else
								console.log(" Data not loaded, retrying ...", callId, callIdFromData);
							setTimeout(function() {
							loadWidgetData(dataWidgetId, callId).then(on_widgetdata_received);		
							}, 400);
						}else {
							alert("Gegevens niet geladen");
						}
					}
                    //console.log(data)

                    
                };
                loadWidgetData(dataWidgetId, callId).then(on_widgetdata_received);
            }, 0);
        }, 200); 
        // kv.value(callId.toLowerCase());
        // kv.trigger("change");        
        // kv.value(callId.toUpperCase());
        // kv.trigger("change");
        // END SET FILTER VALUE
       
        return;
    }
    window.showManglTranscriptStep2 = function(element, widgetId, callId, data) {
        
        if(!data) {
            console.warn("No data afor call: ", callId);
            return;
        }
        var audioPlayer = '<div class="audio-container">' 
        +'  <audio id="audioPlayer" class="audioPlayer" controls preload="none">'
        +'    <source src="/MANGL/Analysis/ServeCallRecording?callId=' + callId + '&acceptRange=true" type="audio/mp3">'
        +'       Your browser does not support the audio element.'
        +'  </audio>'
        +' &nbsp;<span id="displayTimer">0.0</span>'
        +'</div>';

        var html = [
            //'<div class="close">[x]</div>',
			'<button class="p_close btn btn-primary btn-sm delete" data-toggle="tooltip" data-placement="bottom" title="" data-original-title="Sluiten" ><i class="fa fa-times"></i></button>',
            // '<table class="wrapper">',
            // '<tr class="wrap-player"><td>',
            audioPlayer,
            // '</td></tr>',
            // '<tr class="wrap-transcript"><td>'
        ]
        // TODO: tables ?
        html.push('<div id="transcript" class="transcript-container">');
        var isAgent = 0;
        data.forEach(function(value) {
            isAgent = value.speaker_label == 'Agent';
            value.m_timestamp = value.start_milliseconds / 1000;
            value.m_duration = (value.end_milliseconds - value.start_milliseconds) / 1000;
            let h = [
                '<p class="transcript">',
                '<span class="player conf10" conf="1" timestamp="'+value.m_timestamp+'" duration="'+value.m_duration+'">',
                '<b>'+ value.speaker_label + '</b>',
                isAgent ? '<i>' : '' ,
                '<span>' + value.interval_text + '</span>',
                isAgent ? '</i>' : '' ,
                '</p>'
            ]
            html.push(h.join(''))
        });
        html.push('</div>'); //end transcript
        //html.push('</td></tr></table>')

            // <div id="transcript" style="max-height:450px; overflow-y: scroll;">
            



        // var element = $('<div />', {
            // 'class': 'mangl-transcript-popup mtp active-transcript',
            // 'css': { }
        // });
        // activeElement = element;
        element.html(html.join(''))
        element.on('click', '.close, .p_close', function() {
            element.remove();
			if(activeOverlay) activeOverlay.remove();
        })
		if(activeOverlay) {
			activeOverlay.on('click',function() {
				element.remove();
				if(activeOverlay) activeOverlay.remove();
			})
			activeOverlay.appendTo('body');
		}
        element.appendTo('body')
        // fix height:
        var elementHeight = parseInt(element.height(), 10) - parseInt(element.find('.audioPlayer').height(), 10) - 20;
        element.find('.transcript-container').css('max-height', elementHeight + 'px')

        element.on('click', '.transcript-container .player', function() {
                // can't get this to work
            var timeStamp = $( this ).attr( "timestamp" )
            var time = parseFloat(timeStamp)
            //player.currentTime=time;
            //player.currentTime=Math.floor(time);            
            //setTime(time)
            console.log(time)
        })
        function setTime($time) {
            player = element.find('.audioPlayer')[0]
            //player = document.getElementById("audioPlayer")
                    player.currentTime=$time;
                    player.play()
        }

        // add transcript

        // setup events
        (function() {
            var elementD = document.getElementById("displayTimer")
            var progressBar = document.getElementById("progress")
            var index
            setTimeout(function() {
                $("#audioPlayer")[0].play();
            }, 100)
            $("#audioPlayer").on("timeupdate", function(event){
                index = parseFloat(this.currentTime)
                //console.log(this.currentTime)
                elementD.innerHTML = index.toFixed(1)
                element.find( ".player").removeClass('active'); //.css({"background-color": "white", "text-decoration":"none"})
                var active = element.find( ".player" )
                        .filter(function() {
                                        //console.log(Math.abs(parseFloat($(this).attr("timestamp"))))
                            return index > Math.abs(parseFloat($(this).attr("timestamp"))) && index < Math.abs(parseFloat($(this).attr("timestamp")) + parseFloat($(this).attr("duration")))
                            })
                            //.css({"background-color": "yellow", "text-decoration":"underline"})
                            .addClass('active');
                        if(active.length > 0) active[0].scrollIntoView()
            });
            var timeStamp, confidence, speaker
            var elementT = document.getElementById("timeindex")
            var elementC = document.getElementById("confidence")
            var elementS = document.getElementById("speaker")
            element.find('.player').on({
                "click": function movePlayHead() {
                    var timeStamp = $( this ).attr( "timestamp" )
                    var time = parseFloat(timeStamp)
                    console.log(time);
                    setTime(time);},
                "mouseover": function showConfidence() {
                    timeStamp = parseFloat($( this ).attr( "timestamp" ))
                    confidence = $( this ).attr( "conf" )
                    speaker = $( this ).attr( "speaker" )
                
                    
                        if(elementT) elementT.innerHTML = timeStamp.toFixed(3)
                        if(elementC) elementC.innerHTML = confidence
                        if(elementS) elementS.innerHTML = speaker;
                    
            }
            });
        })();

    }
})();